"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Revocable = exports.revocable = void 0;
const _Set = Set;
const _freeze = Object.freeze.bind(Object);
const _revocable = Proxy.revocable.bind(Proxy);
/*
Proxy handler invariants (per MDN):
  apply
    The target must be a callable itself. That is, it must be a function object.
  construct
    The result must be an Object.
  defineProperty
    A property cannot be added, if the target object is not extensible.
    A property cannot be added as or modified to be non-configurable, if it does not exists as a non-configurable own property of the target object.
    A property may not be non-configurable, if a corresponding configurable property of the target object exists.
    If a property has a corresponding target object property then Object.defineProperty(target, prop, descriptor) will not throw an exception.
    In strict mode, a false return value from the defineProperty() handler will throw a TypeError exception.
  deleteProperty
    A property cannot be deleted, if it exists as a non-configurable own property of the target object.
  get
    The value reported for a property must be the same as the value of the corresponding target object property if the target object property is a non-writable, non-configurable own data property.
    The value reported for a property must be undefined if the corresponding target object property is a non-configurable own accessor property that has undefined as its [[Get]] attribute.
  getOwnPropertyDescriptor
    getOwnPropertyDescriptor() must return an object or undefined.
    A property cannot be reported as non-existent, if it exists as a non-configurable own property of the target object.
    A property cannot be reported as non-existent, if it exists as an own property of the target object and the target object is not extensible.
    A property cannot be reported as existent, if it does not exists as an own property of the target object and the target object is not extensible.
    A property cannot be reported as non-configurable, if it does not exists as an own property of the target object or if it exists as a configurable own property of the target object.
    The result of Object.getOwnPropertyDescriptor(target) can be applied to the target object using Object.defineProperty() and will not throw an exception.
  getPrototypeOf
    getPrototypeOf() method must return an object or null.
    If target is not extensible, Object.getPrototypeOf(proxy) method must return the same value as Object.getPrototypeOf(target).
  has
    A property cannot be reported as non-existent, if it exists as a non-configurable own property of the target object.
    A property cannot be reported as non-existent, if it exists as an own property of the target object and the target object is not extensible.
  isExtensible
    Object.isExtensible(proxy) must return the same value as Object.isExtensible(target).
  ownKeys
    The result of ownKeys() must be an array.
    The type of each array element is either a String or a Symbol.
    The result List must contain the keys of all non-configurable own properties of the target object.
    If the target object is not extensible, then the result List must contain all the keys of the own properties of the target object and no other values.
  preventExtensions
    Object.preventExtensions(proxy) only returns true if Object.isExtensible(proxy) is false.
  set
    Return true to indicate that assignment succeeded.
    If the set() method returns false, and the assignment happened in strict-mode code, a TypeError will be thrown.
  setPrototypeOf
    If target is not extensible, the prototype parameter must be the same value as Object.getPrototypeOf(target).
*/
exports.revocable = _freeze((x, addRevoker) => {
    const universalProxyHandler = (x) => new Proxy({}, { get(_, p) {
            return (_t, p2, r) => {
                switch (p) {
                    case "get": {
                        const out = Reflect.get(x, p2, r);
                        if (typeof out === "function")
                            return out.bind(x);
                        return out;
                    }
                    case "getOwnPropertyDescriptor": {
                        const out = Reflect.getOwnPropertyDescriptor(x, p2);
                        if (out)
                            out.configurable = true;
                        return out;
                    }
                    case "isExtensible": return true;
                    case "preventExtensions": return false;
                    default: return Reflect[p](x, p2, r);
                }
            };
        } });
    const { proxy, revoke } = _revocable({}, universalProxyHandler(x));
    addRevoker(revoke);
    return proxy;
});
exports.Revocable = _freeze((x) => {
    var _Revocable_revokers, _Revocable_revoked, _a;
    const out = _freeze((_a = class Revocable extends x {
            constructor() {
                super(...arguments);
                _Revocable_revokers.set(this, new _Set());
                _Revocable_revoked.set(this, false);
                this.revoke = () => {
                    __classPrivateFieldSet(this, _Revocable_revoked, true, "f");
                    __classPrivateFieldGet(this, _Revocable_revokers, "f").forEach(x => {
                        try {
                            x();
                        }
                        catch (_a) { }
                    });
                    __classPrivateFieldGet(this, _Revocable_revokers, "f").clear();
                };
                this.addRevoker = (x) => {
                    if (__classPrivateFieldGet(this, _Revocable_revoked, "f")) {
                        try {
                            x();
                        }
                        catch (_a) { }
                    }
                    else {
                        __classPrivateFieldGet(this, _Revocable_revokers, "f").add(x);
                    }
                };
            }
        },
        _Revocable_revokers = new WeakMap(),
        _Revocable_revoked = new WeakMap(),
        _a));
    _freeze(out.prototype);
    return out;
});
